import { authRoutes } from "resources/constants";
import history from "app/history";

export function logOutUser() {
  // Session is expired, redirect the user to the login
  if (!authRoutes.includes(window.location.pathname)) {
    history.push({ pathname: "/login", state: { sessionExpired: true } });
  }
  // makes a complete reload of page, without using cache
  // forcing the user to reinsert their credentials
  window.location.reload(false);
}

export default logOutUser;
